module.exports = __webpack_public_path__ + "static/media/twitter_rc.4f226bae.svg";